import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pallet-profile-wrapper h-full" }
const _hoisted_2 = { class: "right-sidebar-wrapper h-full flex flex-column" }

import { ref, watch, onBeforeMount } from "vue";
import { get, set, templateRef } from "@vueuse/core";
import CustomerList from "./common/customer/list/index.vue";
import CustomerDetail from "./CustomerDetail/index.vue";
import { ApiCustomerIndexReq, ApiCustomerIndexRes, ApiTagIndexReq, ICustomer, ITag } from "@/clinic/typings";
import { CustomerServices, ClinicService } from "@/clinic/services";
import { AxiosResponse } from "axios";
import { CustomerFilterLineBy } from "@/clinic/typings/enums/customer";


export default /*#__PURE__*/_defineComponent({
  __name: 'RightSideBar',
  props: {
    accountId: null,
    clinicId: null,
    currentCustomer: null
  },
  emits: ["linkedCustomerSuccess"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as {
  accountId: number;
  clinicId: number;
  currentCustomer: number;
};





const customer = ref<ICustomer>({} as ICustomer);
const customers = ref<ICustomer[]>([]);
const listTags = ref<ITag[]>([] as ITag[]);
const visibleSideBar = ref<boolean>(false);
const customerId = ref(0);
const boxCustomerDetail = templateRef<InstanceType<typeof CustomerDetail>>("boxCustomerDetail", null);
const hasLinkCustomer = ref(false);

const onShow = async () => {
  await handleClickShow();
};

const onClose = () => set(visibleSideBar, false);

const setCustomerId = (id: number) => set(customerId, id);

watch(props, async newValue => {
  await handleClickShow();
});

const loadCustomer = async () => {
  if (get(customerId) != 0) {
    const payload = { clinic_id: props.clinicId, id: get(customerId) };
    const { data: customerData } = (await CustomerServices.getCustomer(payload)) as unknown as AxiosResponse<ICustomer>;
    set(customer, get(customerData));
  }
};

const handleClickShow = async () => {
  if (get(customerId) != 0) {
    await loadCustomer();
  } else {
    const { data } = (await CustomerServices.getCustomers(
      {
        clinic_id: props.clinicId,
        term: "",
        rows: 10,
        page: 0,
        filter_line_by: CustomerFilterLineBy.unlinked,
      } as ApiCustomerIndexReq,
      () => undefined,
      (error: any) => undefined
    )) as unknown as AxiosResponse<ApiCustomerIndexRes>;
    const { customers: customersData } = get(data);
    set(customers, customersData as unknown as ICustomer[]);
  }
  const { data: tagsData } = (await ClinicService.listTags({
    clinic_id: props.clinicId as number,
  } as ApiTagIndexReq)) as unknown as AxiosResponse<ITag[]>;
  set(listTags, get(tagsData));
  set(visibleSideBar, true);
};

const onLinkedCustomerSuccess = ({
  customerId,
  accountId,
  customer,
}: {
  customerId: number;
  accountId: number;
  customer: ICustomer;
}) => emits("linkedCustomerSuccess", { customerId, accountId, customer });

const setHasLinkCustomer = (hasLinked: boolean) => set(hasLinkCustomer, hasLinked);

// eslint-disable-next-line no-undef
expose({
  onShow,
  onClose,
  setCustomerId,
  loadCustomer,
  setHasLinkCustomer,
});
onBeforeMount(() => {
  if (props.currentCustomer?.id) {
    setCustomerId(props.currentCustomer?.id);
    loadCustomer();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (customerId.value == 0)
        ? (_openBlock(), _createBlock(CustomerList, {
            key: 0,
            "account-id": props.accountId,
            tags: listTags.value || [],
            customers: customers.value,
            "clinic-id": __props.clinicId,
            onLinkedCustomerSuccess: onLinkedCustomerSuccess
          }, null, 8, ["account-id", "tags", "customers", "clinic-id"]))
        : _createCommentVNode("", true),
      (customerId.value != 0)
        ? (_openBlock(), _createBlock(CustomerDetail, {
            key: 1,
            ref_key: "boxCustomerDetail",
            ref: boxCustomerDetail,
            "customer-id": customerId.value,
            "account-id": props.accountId,
            customer: customer.value,
            tags: listTags.value,
            "clinic-id": __props.clinicId,
            hasLinkCustomer: hasLinkCustomer.value,
            onLinkedCustomerSuccess: onLinkedCustomerSuccess,
            onRefreshCustomer: loadCustomer
          }, null, 8, ["customer-id", "account-id", "customer", "tags", "clinic-id", "hasLinkCustomer"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})